module.exports = __webpack_public_path__ + "508836327bf1114fc7c557dbac356e8e.svg";